// extracted by mini-css-extract-plugin
export default {"badge":"TotalBookingRequestBadge_badge__OwkMb"};